
import React from 'react';
import { Separator } from '@/components/ui/separator';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-fordje-navy-dark text-fordje-gray py-8 border-t border-white/10">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center mb-6">
          <div className="mb-4 md:mb-0 flex items-center gap-3">
            <img 
              src="/lovable-uploads/595a50f5-c631-4403-8464-cad23f811cfe.png" 
              alt="Fordje Logo" 
              className="h-8 w-8"
            />
            <div>
              <h3 className="text-2xl font-bold text-white mb-1 font-ubuntu">Fordje</h3>
              <p className="text-fordje-gray">Build without surprises</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 md:gap-8 justify-center md:justify-start">
            <Link to="/" className="text-fordje-gray hover:text-white transition-colors">Home</Link>
            <Link to="/blog" className="text-fordje-gray hover:text-white transition-colors">Insights</Link>
            <Link to="/about" className="text-fordje-gray hover:text-white transition-colors">About</Link>
            <Link to="/request-demo" className="text-fordje-gray hover:text-white transition-colors">Contact</Link>
          </div>
        </div>
        <Separator className="bg-fordje-navy-light" />
        <div className="flex flex-col md:flex-row justify-between items-center mt-6 text-sm">
          <p>&copy; {currentYear} Fordje. All rights reserved.</p>
          <div className="flex items-center gap-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-fordje-gray hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-fordje-gray hover:text-white transition-colors">Terms of Service</Link>
            <a 
              href="https://www.linkedin.com/company/102014249/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-fordje-gray hover:text-white transition-colors"
              aria-label="Follow Fordje on LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
